module.exports = "/static/assets/75e825d30f294735fcc1468bd74cdb71.png";